import { render, staticRenderFns } from "./NotificationWish.vue?vue&type=template&id=295524c8&scoped=true&"
import script from "./NotificationWish.vue?vue&type=script&lang=js&"
export * from "./NotificationWish.vue?vue&type=script&lang=js&"
import style0 from "./NotificationWish.vue?vue&type=style&index=0&id=295524c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295524c8",
  null
  
)

export default component.exports